import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit } from '@angular/core';

import { Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsTeaser } from '@fcom/core-api';
import { isNotEmpty, safeMap } from '@fcom/core/utils';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

interface TextWithIcon {
  iconName: SvgLibraryIcon;
  text: string;
}

@Component({
  selector: 'cms-list-with-icons',
  templateUrl: './cms-list-with-icons.component.html',
  styleUrls: ['./cms-list-with-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsListWithIconsComponent implements OnInit {
  private themeService = inject(FinnairThemeService);

  @Input()
  content$: Observable<CmsCollection>;
  @Input()
  useTeaserTitle: boolean;

  items$: Observable<TextWithIcon[]>;

  isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  ngOnInit(): void {
    this.items$ = this.content$.pipe(
      map((content: CmsCollection) => safeMap(content, (c: CmsCollection) => c.items)),
      map((items: CmsTeaser[]) =>
        items?.map((item) => ({
          text: this.useTeaserTitle ? item.teaserTitle : item.teaserText,
          iconName: item.localSettings?.iconName as SvgLibraryIcon,
        }))
      ),
      filter(isNotEmpty),
      distinctUntilChanged()
    );
  }
}
